import { TOKENDATA } from "../components/common/header";
import { CURRENTVIEW, FILTERDATA, TIMELINE, APPROACH } from "../utils";

const initialState = {
  allFilters: {
    district: [],
    l1: [],
    l2: [],
    l3: [],
    supplier: []
  },

  timeline:null,
  approach:null,

  filterOptions: {
    district: [],
    l1: [],
    l2: [],
    l3: [],
    supplier: []
  },

  currentView: {
    isSummaryView: true,
    viewBy: 'Supplier',
    selectedHighlight: null,
    filters: {
      district: [],
      l1: [],
      l2: [],
      l3: [],
      supplier: []
    },
  },
  token: null,
};

const CommonReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FILTERDATA:
      return {
        ...state,
        allFilters: { ...state.allFilters, ...action.data }
      }
    case CURRENTVIEW:
      return {
        ...state,
        currentView: action.data
      }
      case TOKENDATA:
      return {
        ...state,
        token: action.data,
      };
      case TIMELINE:
      return {
        ...state,
        timeline: action.data,
      };
      case APPROACH:
      return {
        ...state,
        approach: action.data,
      };
  }
  return state;
};

export default CommonReducer;
